/* eslint-disable */
import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Bigdecimal: { input: number; output: number; }
  Boolean1: { input: boolean; output: boolean; }
  Float64: { input: number; output: number; }
  Int32: { input: number; output: number; }
  Int64: { input: number; output: number; }
  String1: { input: string; output: string; }
};

export type Accounts = {
  __typename?: 'Accounts';
  accountCode: Scalars['String']['output'];
  bills?: Maybe<Array<Bills>>;
  defaultLocationId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  primaryEmail: Scalars['String']['output'];
  primaryName: Scalars['String']['output'];
  primaryPhone: Scalars['String']['output'];
};


export type AccountsBillsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BillsOrderByExp>>;
  where?: InputMaybe<BillsBoolExp>;
};

export type AccountsAggExp = {
  __typename?: 'AccountsAggExp';
  _count: Scalars['Int']['output'];
  accountCode: StringAggExp;
  defaultLocationId: StringAggExp;
  id: StringAggExp;
  name: StringAggExp;
  primaryEmail: StringAggExp;
  primaryName: StringAggExp;
  primaryPhone: StringAggExp;
};

export type AccountsBoolExp = {
  _and?: InputMaybe<Array<AccountsBoolExp>>;
  _not?: InputMaybe<AccountsBoolExp>;
  _or?: InputMaybe<Array<AccountsBoolExp>>;
  accountCode?: InputMaybe<StringBoolExp>;
  defaultLocationId?: InputMaybe<StringBoolExp>;
  id?: InputMaybe<StringBoolExp>;
  name?: InputMaybe<StringBoolExp>;
  primaryEmail?: InputMaybe<StringBoolExp>;
  primaryName?: InputMaybe<StringBoolExp>;
  primaryPhone?: InputMaybe<StringBoolExp>;
};

export type AccountsFilterInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AccountsOrderByExp>>;
  where?: InputMaybe<AccountsBoolExp>;
};

export type AccountsOrderByExp = {
  accountCode?: InputMaybe<OrderBy>;
  defaultLocationId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  primaryEmail?: InputMaybe<OrderBy>;
  primaryName?: InputMaybe<OrderBy>;
  primaryPhone?: InputMaybe<OrderBy>;
};

export type AsnLines = {
  __typename?: 'AsnLines';
  asnId: Scalars['String']['output'];
  createdAt: Scalars['String1']['output'];
  description: Scalars['String']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  externalSkuName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lineNumber: Scalars['Int32']['output'];
  manufacturerIdentificationCode?: Maybe<Scalars['String']['output']>;
  qtyExpected: Scalars['Int32']['output'];
  qtyOutstanding: Scalars['Int32']['output'];
  qtyReceived: Scalars['Int32']['output'];
  skuId: Scalars['String']['output'];
  skuName: Scalars['String']['output'];
  status: Scalars['String']['output'];
  subInventoryDetails: Scalars['String']['output'];
  unitCostTotal?: Maybe<Scalars['Bigdecimal']['output']>;
  unitLandedCost?: Maybe<Scalars['Bigdecimal']['output']>;
  unitPurchaseCost?: Maybe<Scalars['Bigdecimal']['output']>;
  updatedAt: Scalars['String1']['output'];
};

export type AsnLinesBoolExp = {
  _and?: InputMaybe<Array<AsnLinesBoolExp>>;
  _not?: InputMaybe<AsnLinesBoolExp>;
  _or?: InputMaybe<Array<AsnLinesBoolExp>>;
  asnId?: InputMaybe<StringBoolExp>;
  createdAt?: InputMaybe<DateTime643BoolExp>;
  description?: InputMaybe<StringBoolExp>;
  externalId?: InputMaybe<StringBoolExp>;
  externalSkuName?: InputMaybe<StringBoolExp>;
  id?: InputMaybe<StringBoolExp>;
  lineNumber?: InputMaybe<Int32BoolExp>;
  manufacturerIdentificationCode?: InputMaybe<StringBoolExp>;
  qtyExpected?: InputMaybe<Int32BoolExp>;
  qtyOutstanding?: InputMaybe<Int32BoolExp>;
  qtyReceived?: InputMaybe<Int32BoolExp>;
  skuId?: InputMaybe<StringBoolExp>;
  skuName?: InputMaybe<StringBoolExp>;
  status?: InputMaybe<StringBoolExp>;
  subInventoryDetails?: InputMaybe<StringBoolExp>;
  unitCostTotal?: InputMaybe<Decimal387BoolExp>;
  unitLandedCost?: InputMaybe<Decimal387BoolExp>;
  unitPurchaseCost?: InputMaybe<Decimal387BoolExp>;
  updatedAt?: InputMaybe<DateTime643BoolExp>;
};

export type Asns = {
  __typename?: 'Asns';
  accountId: Scalars['String']['output'];
  arrivedAt?: Maybe<Scalars['String1']['output']>;
  asnLines?: Maybe<Array<AsnLines>>;
  carrier?: Maybe<Scalars['String']['output']>;
  closedAt: Scalars['String1']['output'];
  createdAt: Scalars['String1']['output'];
  currency: Scalars['String']['output'];
  expectedAt?: Maybe<Scalars['String1']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  fromAddressAddress1: Scalars['String']['output'];
  fromAddressAddress2?: Maybe<Scalars['String']['output']>;
  fromAddressCity?: Maybe<Scalars['String']['output']>;
  fromAddressCompanyName?: Maybe<Scalars['String']['output']>;
  fromAddressContactEmail?: Maybe<Scalars['String']['output']>;
  fromAddressContactName: Scalars['String']['output'];
  fromAddressContactNumber?: Maybe<Scalars['String']['output']>;
  fromAddressCountry: Scalars['String']['output'];
  fromAddressPostcode?: Maybe<Scalars['String']['output']>;
  fromAddressState?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isRolledOver: Scalars['Boolean1']['output'];
  location?: Maybe<Locations>;
  locationId: Scalars['String']['output'];
  locationName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  originAsnId?: Maybe<Scalars['String']['output']>;
  presell?: Maybe<Scalars['Boolean1']['output']>;
  qtyExpected?: Maybe<Scalars['Int32']['output']>;
  qtyOutstanding: Scalars['Int32']['output'];
  qtyReceived?: Maybe<Scalars['Int32']['output']>;
  receiptStatus: Scalars['String']['output'];
  reference?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  trackingNumber?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String1']['output'];
  warehouseLocationId?: Maybe<Scalars['String']['output']>;
  warehouseLocationName?: Maybe<Scalars['String']['output']>;
};


export type AsnsAsnLinesArgs = {
  where?: InputMaybe<AsnLinesBoolExp>;
};

export type AsnsAggExp = {
  __typename?: 'AsnsAggExp';
  _count: Scalars['Int']['output'];
  accountId: StringAggExp;
  arrivedAt: DateTime643AggExp;
  carrier: StringAggExp;
  closedAt: DateTime643AggExp;
  createdAt: DateTime643AggExp;
  currency: StringAggExp;
  expectedAt: DateTime643AggExp;
  externalId: StringAggExp;
  fromAddressAddress1: StringAggExp;
  fromAddressAddress2: StringAggExp;
  fromAddressCity: StringAggExp;
  fromAddressCompanyName: StringAggExp;
  fromAddressContactEmail: StringAggExp;
  fromAddressContactName: StringAggExp;
  fromAddressContactNumber: StringAggExp;
  fromAddressCountry: StringAggExp;
  fromAddressPostcode: StringAggExp;
  fromAddressState: StringAggExp;
  id: StringAggExp;
  isRolledOver: BoolAggExp;
  locationId: StringAggExp;
  locationName: StringAggExp;
  name: StringAggExp;
  note: StringAggExp;
  originAsnId: StringAggExp;
  presell: BoolAggExp;
  qtyExpected: Int32AggExp;
  qtyOutstanding: Int32AggExp;
  qtyReceived: Int32AggExp;
  receiptStatus: StringAggExp;
  reference: StringAggExp;
  status: StringAggExp;
  trackingNumber: StringAggExp;
  updatedAt: DateTime643AggExp;
  warehouseLocationId: StringAggExp;
  warehouseLocationName: StringAggExp;
};

export type AsnsBoolExp = {
  _and?: InputMaybe<Array<AsnsBoolExp>>;
  _not?: InputMaybe<AsnsBoolExp>;
  _or?: InputMaybe<Array<AsnsBoolExp>>;
  accountId?: InputMaybe<StringBoolExp>;
  arrivedAt?: InputMaybe<DateTime643BoolExp>;
  asnLines?: InputMaybe<AsnLinesBoolExp>;
  carrier?: InputMaybe<StringBoolExp>;
  closedAt?: InputMaybe<DateTime643BoolExp>;
  createdAt?: InputMaybe<DateTime643BoolExp>;
  currency?: InputMaybe<StringBoolExp>;
  expectedAt?: InputMaybe<DateTime643BoolExp>;
  externalId?: InputMaybe<StringBoolExp>;
  fromAddressAddress1?: InputMaybe<StringBoolExp>;
  fromAddressAddress2?: InputMaybe<StringBoolExp>;
  fromAddressCity?: InputMaybe<StringBoolExp>;
  fromAddressCompanyName?: InputMaybe<StringBoolExp>;
  fromAddressContactEmail?: InputMaybe<StringBoolExp>;
  fromAddressContactName?: InputMaybe<StringBoolExp>;
  fromAddressContactNumber?: InputMaybe<StringBoolExp>;
  fromAddressCountry?: InputMaybe<StringBoolExp>;
  fromAddressPostcode?: InputMaybe<StringBoolExp>;
  fromAddressState?: InputMaybe<StringBoolExp>;
  id?: InputMaybe<StringBoolExp>;
  isRolledOver?: InputMaybe<BoolBoolExp>;
  location?: InputMaybe<LocationsBoolExp>;
  locationId?: InputMaybe<StringBoolExp>;
  locationName?: InputMaybe<StringBoolExp>;
  name?: InputMaybe<StringBoolExp>;
  note?: InputMaybe<StringBoolExp>;
  originAsnId?: InputMaybe<StringBoolExp>;
  presell?: InputMaybe<BoolBoolExp>;
  qtyExpected?: InputMaybe<Int32BoolExp>;
  qtyOutstanding?: InputMaybe<Int32BoolExp>;
  qtyReceived?: InputMaybe<Int32BoolExp>;
  receiptStatus?: InputMaybe<StringBoolExp>;
  reference?: InputMaybe<StringBoolExp>;
  status?: InputMaybe<StringBoolExp>;
  trackingNumber?: InputMaybe<StringBoolExp>;
  updatedAt?: InputMaybe<DateTime643BoolExp>;
  warehouseLocationId?: InputMaybe<StringBoolExp>;
  warehouseLocationName?: InputMaybe<StringBoolExp>;
};

export type AsnsFilterInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AsnsOrderByExp>>;
  where?: InputMaybe<AsnsBoolExp>;
};

export type AsnsOrderByExp = {
  accountId?: InputMaybe<OrderBy>;
  arrivedAt?: InputMaybe<OrderBy>;
  carrier?: InputMaybe<OrderBy>;
  closedAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  expectedAt?: InputMaybe<OrderBy>;
  externalId?: InputMaybe<OrderBy>;
  fromAddressAddress1?: InputMaybe<OrderBy>;
  fromAddressAddress2?: InputMaybe<OrderBy>;
  fromAddressCity?: InputMaybe<OrderBy>;
  fromAddressCompanyName?: InputMaybe<OrderBy>;
  fromAddressContactEmail?: InputMaybe<OrderBy>;
  fromAddressContactName?: InputMaybe<OrderBy>;
  fromAddressContactNumber?: InputMaybe<OrderBy>;
  fromAddressCountry?: InputMaybe<OrderBy>;
  fromAddressPostcode?: InputMaybe<OrderBy>;
  fromAddressState?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isRolledOver?: InputMaybe<OrderBy>;
  location?: InputMaybe<LocationsOrderByExp>;
  locationId?: InputMaybe<OrderBy>;
  locationName?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  note?: InputMaybe<OrderBy>;
  originAsnId?: InputMaybe<OrderBy>;
  presell?: InputMaybe<OrderBy>;
  qtyExpected?: InputMaybe<OrderBy>;
  qtyOutstanding?: InputMaybe<OrderBy>;
  qtyReceived?: InputMaybe<OrderBy>;
  receiptStatus?: InputMaybe<OrderBy>;
  reference?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  trackingNumber?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  warehouseLocationId?: InputMaybe<OrderBy>;
  warehouseLocationName?: InputMaybe<OrderBy>;
};

export type AutomationWorkflows = {
  __typename?: 'AutomationWorkflows';
  createdAt: Scalars['String1']['output'];
  dataType: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  rules: Scalars['String']['output'];
  scopeId: Scalars['String']['output'];
  scopeType: Scalars['String']['output'];
  status: Scalars['String']['output'];
  triggerType: Scalars['String']['output'];
  updatedAt: Scalars['String1']['output'];
};

export type AutomationWorkflowsAggExp = {
  __typename?: 'AutomationWorkflowsAggExp';
  _count: Scalars['Int']['output'];
  createdAt: DateTime643AggExp;
  dataType: StringAggExp;
  description: StringAggExp;
  id: StringAggExp;
  name: StringAggExp;
  rules: StringAggExp;
  scopeId: StringAggExp;
  scopeType: StringAggExp;
  status: StringAggExp;
  triggerType: StringAggExp;
  updatedAt: DateTime643AggExp;
};

export type AutomationWorkflowsBoolExp = {
  _and?: InputMaybe<Array<AutomationWorkflowsBoolExp>>;
  _not?: InputMaybe<AutomationWorkflowsBoolExp>;
  _or?: InputMaybe<Array<AutomationWorkflowsBoolExp>>;
  createdAt?: InputMaybe<DateTime643BoolExp>;
  dataType?: InputMaybe<StringBoolExp>;
  description?: InputMaybe<StringBoolExp>;
  id?: InputMaybe<StringBoolExp>;
  name?: InputMaybe<StringBoolExp>;
  rules?: InputMaybe<StringBoolExp>;
  scopeId?: InputMaybe<StringBoolExp>;
  scopeType?: InputMaybe<StringBoolExp>;
  status?: InputMaybe<StringBoolExp>;
  triggerType?: InputMaybe<StringBoolExp>;
  updatedAt?: InputMaybe<DateTime643BoolExp>;
};

export type AutomationWorkflowsOrderByExp = {
  createdAt?: InputMaybe<OrderBy>;
  dataType?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  rules?: InputMaybe<OrderBy>;
  scopeId?: InputMaybe<OrderBy>;
  scopeType?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  triggerType?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

export type Bills = {
  __typename?: 'Bills';
  account?: Maybe<Accounts>;
  accountId: Scalars['String']['output'];
  billNumber: Scalars['Int32']['output'];
  billTotal: Scalars['Bigdecimal']['output'];
  id: Scalars['String']['output'];
  invoiceId?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Locations>;
  locationId: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  periodEnd: Scalars['String1']['output'];
  periodStart: Scalars['String1']['output'];
  recalculatedAt?: Maybe<Scalars['String1']['output']>;
  serviceAgreementId: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type BillsAggExp = {
  __typename?: 'BillsAggExp';
  _count: Scalars['Int']['output'];
  accountId: StringAggExp;
  billNumber: Int32AggExp;
  billTotal: Decimal384AggExp;
  id: StringAggExp;
  invoiceId: StringAggExp;
  locationId: StringAggExp;
  name: StringAggExp;
  periodEnd: DateAggExp;
  periodStart: DateAggExp;
  recalculatedAt: DateTime643AggExp;
  serviceAgreementId: StringAggExp;
  status: StringAggExp;
};

export type BillsBoolExp = {
  _and?: InputMaybe<Array<BillsBoolExp>>;
  _not?: InputMaybe<BillsBoolExp>;
  _or?: InputMaybe<Array<BillsBoolExp>>;
  account?: InputMaybe<AccountsBoolExp>;
  accountId?: InputMaybe<StringBoolExp>;
  billNumber?: InputMaybe<Int32BoolExp>;
  billTotal?: InputMaybe<Decimal384BoolExp>;
  id?: InputMaybe<StringBoolExp>;
  invoiceId?: InputMaybe<StringBoolExp>;
  location?: InputMaybe<LocationsBoolExp>;
  locationId?: InputMaybe<StringBoolExp>;
  name?: InputMaybe<StringBoolExp>;
  periodEnd?: InputMaybe<DateBoolExp>;
  periodStart?: InputMaybe<DateBoolExp>;
  recalculatedAt?: InputMaybe<DateTimeBoolExp>;
  serviceAgreementId?: InputMaybe<StringBoolExp>;
  status?: InputMaybe<StringBoolExp>;
};

export type BillsFilterInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BillsOrderByExp>>;
  where?: InputMaybe<BillsBoolExp>;
};

export type BillsOrderByExp = {
  account?: InputMaybe<AccountsOrderByExp>;
  accountId?: InputMaybe<OrderBy>;
  billNumber?: InputMaybe<OrderBy>;
  billTotal?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invoiceId?: InputMaybe<OrderBy>;
  location?: InputMaybe<LocationsOrderByExp>;
  locationId?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  periodEnd?: InputMaybe<OrderBy>;
  periodStart?: InputMaybe<OrderBy>;
  recalculatedAt?: InputMaybe<OrderBy>;
  serviceAgreementId?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
};

export type BoolAggExp = {
  __typename?: 'BoolAggExp';
  _count: Scalars['Int']['output'];
  _count_distinct: Scalars['Int']['output'];
};

export type BoolBoolExp = {
  _and?: InputMaybe<Array<BoolBoolExp>>;
  _eq?: InputMaybe<Scalars['Boolean1']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean1']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean1']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean1']['input']>>;
  _not?: InputMaybe<BoolBoolExp>;
  _or?: InputMaybe<Array<BoolBoolExp>>;
};

export type Channels = {
  __typename?: 'Channels';
  accountId: Scalars['String']['output'];
  brandName?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String1']['output'];
  fulfillmentLocationIds: Scalars['String']['output'];
  id: Scalars['String']['output'];
  listings?: Maybe<Array<Listings>>;
  name: Scalars['String']['output'];
  updatedAt: Scalars['String1']['output'];
};


export type ChannelsListingsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ListingsOrderByExp>>;
  where?: InputMaybe<ListingsBoolExp>;
};

export type ChannelsAggExp = {
  __typename?: 'ChannelsAggExp';
  _count: Scalars['Int']['output'];
  accountId: StringAggExp;
  brandName: StringAggExp;
  category: StringAggExp;
  createdAt: DateTime643AggExp;
  fulfillmentLocationIds: StringAggExp;
  id: StringAggExp;
  name: StringAggExp;
  updatedAt: DateTime643AggExp;
};

export type ChannelsBoolExp = {
  _and?: InputMaybe<Array<ChannelsBoolExp>>;
  _not?: InputMaybe<ChannelsBoolExp>;
  _or?: InputMaybe<Array<ChannelsBoolExp>>;
  accountId?: InputMaybe<StringBoolExp>;
  brandName?: InputMaybe<StringBoolExp>;
  category?: InputMaybe<StringBoolExp>;
  createdAt?: InputMaybe<DateTime643BoolExp>;
  fulfillmentLocationIds?: InputMaybe<StringBoolExp>;
  id?: InputMaybe<StringBoolExp>;
  listings?: InputMaybe<ListingsBoolExp>;
  name?: InputMaybe<StringBoolExp>;
  updatedAt?: InputMaybe<DateTime643BoolExp>;
};

export type ChannelsFilterInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ChannelsOrderByExp>>;
  where?: InputMaybe<ChannelsBoolExp>;
};

export type ChannelsOrderByExp = {
  accountId?: InputMaybe<OrderBy>;
  brandName?: InputMaybe<OrderBy>;
  category?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  fulfillmentLocationIds?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

export type DateAggExp = {
  __typename?: 'DateAggExp';
  _count: Scalars['Int']['output'];
  _count_distinct: Scalars['Int']['output'];
  max: Scalars['String1']['output'];
  min: Scalars['String1']['output'];
};

export type DateBoolExp = {
  _and?: InputMaybe<Array<DateBoolExp>>;
  _eq?: InputMaybe<Scalars['String1']['input']>;
  _gt?: InputMaybe<Scalars['String1']['input']>;
  _gte?: InputMaybe<Scalars['String1']['input']>;
  _in?: InputMaybe<Array<Scalars['String1']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['String1']['input']>;
  _lte?: InputMaybe<Scalars['String1']['input']>;
  _neq?: InputMaybe<Scalars['String1']['input']>;
  _nin?: InputMaybe<Array<Scalars['String1']['input']>>;
  _not?: InputMaybe<DateBoolExp>;
  _or?: InputMaybe<Array<DateBoolExp>>;
};

export type DateTime643AggExp = {
  __typename?: 'DateTime643AggExp';
  _count: Scalars['Int']['output'];
  _count_distinct: Scalars['Int']['output'];
  max: Scalars['String1']['output'];
  min: Scalars['String1']['output'];
};

export type DateTime643BoolExp = {
  _and?: InputMaybe<Array<DateTime643BoolExp>>;
  _eq?: InputMaybe<Scalars['String1']['input']>;
  _gt?: InputMaybe<Scalars['String1']['input']>;
  _gte?: InputMaybe<Scalars['String1']['input']>;
  _in?: InputMaybe<Array<Scalars['String1']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['String1']['input']>;
  _lte?: InputMaybe<Scalars['String1']['input']>;
  _neq?: InputMaybe<Scalars['String1']['input']>;
  _nin?: InputMaybe<Array<Scalars['String1']['input']>>;
  _not?: InputMaybe<DateTime643BoolExp>;
  _or?: InputMaybe<Array<DateTime643BoolExp>>;
};

export type DateTimeBoolExp = {
  _and?: InputMaybe<Array<DateTimeBoolExp>>;
  _eq?: InputMaybe<Scalars['String1']['input']>;
  _gt?: InputMaybe<Scalars['String1']['input']>;
  _gte?: InputMaybe<Scalars['String1']['input']>;
  _in?: InputMaybe<Array<Scalars['String1']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['String1']['input']>;
  _lte?: InputMaybe<Scalars['String1']['input']>;
  _neq?: InputMaybe<Scalars['String1']['input']>;
  _nin?: InputMaybe<Array<Scalars['String1']['input']>>;
  _not?: InputMaybe<DateTimeBoolExp>;
  _or?: InputMaybe<Array<DateTimeBoolExp>>;
};

export type Decimal384AggExp = {
  __typename?: 'Decimal384AggExp';
  _count: Scalars['Int']['output'];
  _count_distinct: Scalars['Int']['output'];
  avg: Scalars['Float64']['output'];
  max: Scalars['Bigdecimal']['output'];
  min: Scalars['Bigdecimal']['output'];
  stddev_pop: Scalars['Float64']['output'];
  stddev_samp: Scalars['Float64']['output'];
  sum: Scalars['Bigdecimal']['output'];
  var_pop: Scalars['Float64']['output'];
  var_samp: Scalars['Float64']['output'];
};

export type Decimal384BoolExp = {
  _and?: InputMaybe<Array<Decimal384BoolExp>>;
  _eq?: InputMaybe<Scalars['Bigdecimal']['input']>;
  _gt?: InputMaybe<Scalars['Bigdecimal']['input']>;
  _gte?: InputMaybe<Scalars['Bigdecimal']['input']>;
  _in?: InputMaybe<Array<Scalars['Bigdecimal']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Bigdecimal']['input']>;
  _lte?: InputMaybe<Scalars['Bigdecimal']['input']>;
  _neq?: InputMaybe<Scalars['Bigdecimal']['input']>;
  _nin?: InputMaybe<Array<Scalars['Bigdecimal']['input']>>;
  _not?: InputMaybe<Decimal384BoolExp>;
  _or?: InputMaybe<Array<Decimal384BoolExp>>;
};

export type Decimal387AggExp = {
  __typename?: 'Decimal387AggExp';
  _count: Scalars['Int']['output'];
  _count_distinct: Scalars['Int']['output'];
  avg: Scalars['Float64']['output'];
  max: Scalars['Bigdecimal']['output'];
  min: Scalars['Bigdecimal']['output'];
  stddev_pop: Scalars['Float64']['output'];
  stddev_samp: Scalars['Float64']['output'];
  sum: Scalars['Bigdecimal']['output'];
  var_pop: Scalars['Float64']['output'];
  var_samp: Scalars['Float64']['output'];
};

export type Decimal387BoolExp = {
  _and?: InputMaybe<Array<Decimal387BoolExp>>;
  _eq?: InputMaybe<Scalars['Bigdecimal']['input']>;
  _gt?: InputMaybe<Scalars['Bigdecimal']['input']>;
  _gte?: InputMaybe<Scalars['Bigdecimal']['input']>;
  _in?: InputMaybe<Array<Scalars['Bigdecimal']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Bigdecimal']['input']>;
  _lte?: InputMaybe<Scalars['Bigdecimal']['input']>;
  _neq?: InputMaybe<Scalars['Bigdecimal']['input']>;
  _nin?: InputMaybe<Array<Scalars['Bigdecimal']['input']>>;
  _not?: InputMaybe<Decimal387BoolExp>;
  _or?: InputMaybe<Array<Decimal387BoolExp>>;
};

export type Int32AggExp = {
  __typename?: 'Int32AggExp';
  _count: Scalars['Int']['output'];
  _count_distinct: Scalars['Int']['output'];
  avg: Scalars['Float64']['output'];
  max: Scalars['Int32']['output'];
  min: Scalars['Int32']['output'];
  stddev_pop: Scalars['Float64']['output'];
  stddev_samp: Scalars['Float64']['output'];
  sum: Scalars['Int64']['output'];
  var_pop: Scalars['Float64']['output'];
  var_samp: Scalars['Float64']['output'];
};

export type Int32BoolExp = {
  _and?: InputMaybe<Array<Int32BoolExp>>;
  _eq?: InputMaybe<Scalars['Int32']['input']>;
  _gt?: InputMaybe<Scalars['Int32']['input']>;
  _gte?: InputMaybe<Scalars['Int32']['input']>;
  _in?: InputMaybe<Array<Scalars['Int32']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int32']['input']>;
  _lte?: InputMaybe<Scalars['Int32']['input']>;
  _neq?: InputMaybe<Scalars['Int32']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int32']['input']>>;
  _not?: InputMaybe<Int32BoolExp>;
  _or?: InputMaybe<Array<Int32BoolExp>>;
};

export type Inventories = {
  __typename?: 'Inventories';
  accountId: Scalars['String']['output'];
  accountName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String1']['output'];
  externalSkuName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  locationId: Scalars['String']['output'];
  locationName?: Maybe<Scalars['String']['output']>;
  qtyAllocated: Scalars['Int32']['output'];
  qtyAvailable: Scalars['Int32']['output'];
  qtyCommittable: Scalars['Int32']['output'];
  qtyCommitted: Scalars['Int32']['output'];
  qtyExpected: Scalars['Int32']['output'];
  qtyOnHand: Scalars['Int32']['output'];
  qtyReserved: Scalars['Int32']['output'];
  reconciledAt?: Maybe<Scalars['String1']['output']>;
  sku?: Maybe<Skus>;
  skuDescription?: Maybe<Scalars['String']['output']>;
  skuId: Scalars['String']['output'];
  skuName?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  updatedAt: Scalars['String1']['output'];
};

export type InventoriesAggExp = {
  __typename?: 'InventoriesAggExp';
  _count: Scalars['Int']['output'];
  accountId: StringAggExp;
  accountName: StringAggExp;
  createdAt: DateTime643AggExp;
  externalSkuName: StringAggExp;
  id: StringAggExp;
  locationId: StringAggExp;
  locationName: StringAggExp;
  qtyAllocated: Int32AggExp;
  qtyAvailable: Int32AggExp;
  qtyCommittable: Int32AggExp;
  qtyCommitted: Int32AggExp;
  qtyExpected: Int32AggExp;
  qtyOnHand: Int32AggExp;
  qtyReserved: Int32AggExp;
  reconciledAt: DateTime643AggExp;
  skuDescription: StringAggExp;
  skuId: StringAggExp;
  skuName: StringAggExp;
  status: StringAggExp;
  updatedAt: DateTime643AggExp;
};

export type InventoriesBoolExp = {
  _and?: InputMaybe<Array<InventoriesBoolExp>>;
  _not?: InputMaybe<InventoriesBoolExp>;
  _or?: InputMaybe<Array<InventoriesBoolExp>>;
  accountId?: InputMaybe<StringBoolExp>;
  accountName?: InputMaybe<StringBoolExp>;
  createdAt?: InputMaybe<DateTime643BoolExp>;
  externalSkuName?: InputMaybe<StringBoolExp>;
  id?: InputMaybe<StringBoolExp>;
  locationId?: InputMaybe<StringBoolExp>;
  locationName?: InputMaybe<StringBoolExp>;
  qtyAllocated?: InputMaybe<Int32BoolExp>;
  qtyAvailable?: InputMaybe<Int32BoolExp>;
  qtyCommittable?: InputMaybe<Int32BoolExp>;
  qtyCommitted?: InputMaybe<Int32BoolExp>;
  qtyExpected?: InputMaybe<Int32BoolExp>;
  qtyOnHand?: InputMaybe<Int32BoolExp>;
  qtyReserved?: InputMaybe<Int32BoolExp>;
  reconciledAt?: InputMaybe<DateTime643BoolExp>;
  sku?: InputMaybe<SkusBoolExp>;
  skuDescription?: InputMaybe<StringBoolExp>;
  skuId?: InputMaybe<StringBoolExp>;
  skuName?: InputMaybe<StringBoolExp>;
  status?: InputMaybe<StringBoolExp>;
  updatedAt?: InputMaybe<DateTime643BoolExp>;
};

export type InventoriesFilterInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InventoriesOrderByExp>>;
  where?: InputMaybe<InventoriesBoolExp>;
};

export type InventoriesOrderByExp = {
  accountId?: InputMaybe<OrderBy>;
  accountName?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  externalSkuName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  locationId?: InputMaybe<OrderBy>;
  locationName?: InputMaybe<OrderBy>;
  qtyAllocated?: InputMaybe<OrderBy>;
  qtyAvailable?: InputMaybe<OrderBy>;
  qtyCommittable?: InputMaybe<OrderBy>;
  qtyCommitted?: InputMaybe<OrderBy>;
  qtyExpected?: InputMaybe<OrderBy>;
  qtyOnHand?: InputMaybe<OrderBy>;
  qtyReserved?: InputMaybe<OrderBy>;
  reconciledAt?: InputMaybe<OrderBy>;
  sku?: InputMaybe<SkusOrderByExp>;
  skuDescription?: InputMaybe<OrderBy>;
  skuId?: InputMaybe<OrderBy>;
  skuName?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

export type Listings = {
  __typename?: 'Listings';
  accountId: Scalars['String']['output'];
  channel?: Maybe<Channels>;
  channelId: Scalars['String']['output'];
  channelName: Scalars['String']['output'];
  collectionsJson: Scalars['String']['output'];
  createdAt: Scalars['String1']['output'];
  description: Scalars['String']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  externalSkuName?: Maybe<Scalars['String']['output']>;
  fulfillmentStrategy: Scalars['String']['output'];
  id: Scalars['String']['output'];
  listingStrategy: Scalars['String']['output'];
  name: Scalars['String']['output'];
  qtyAvailable: Scalars['Int32']['output'];
  qtyExpected: Scalars['Int32']['output'];
  qtyListed: Scalars['Int32']['output'];
  qtyReserved: Scalars['Int32']['output'];
  reconciledAt: Scalars['String1']['output'];
  refreshedAt: Scalars['String1']['output'];
  sku?: Maybe<Skus>;
  skuId?: Maybe<Scalars['String']['output']>;
  skuName?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  updatedAt: Scalars['String1']['output'];
};

export type ListingsAggExp = {
  __typename?: 'ListingsAggExp';
  _count: Scalars['Int']['output'];
  accountId: StringAggExp;
  channelId: StringAggExp;
  channelName: StringAggExp;
  collectionsJson: StringAggExp;
  createdAt: DateTime643AggExp;
  description: StringAggExp;
  externalId: StringAggExp;
  externalSkuName: StringAggExp;
  fulfillmentStrategy: StringAggExp;
  id: StringAggExp;
  listingStrategy: StringAggExp;
  name: StringAggExp;
  qtyAvailable: Int32AggExp;
  qtyExpected: Int32AggExp;
  qtyListed: Int32AggExp;
  qtyReserved: Int32AggExp;
  reconciledAt: DateTime643AggExp;
  refreshedAt: DateTime643AggExp;
  skuId: StringAggExp;
  skuName: StringAggExp;
  status: StringAggExp;
  updatedAt: DateTime643AggExp;
};

export type ListingsBoolExp = {
  _and?: InputMaybe<Array<ListingsBoolExp>>;
  _not?: InputMaybe<ListingsBoolExp>;
  _or?: InputMaybe<Array<ListingsBoolExp>>;
  accountId?: InputMaybe<StringBoolExp>;
  channel?: InputMaybe<ChannelsBoolExp>;
  channelId?: InputMaybe<StringBoolExp>;
  channelName?: InputMaybe<StringBoolExp>;
  collectionsJson?: InputMaybe<StringBoolExp>;
  createdAt?: InputMaybe<DateTime643BoolExp>;
  description?: InputMaybe<StringBoolExp>;
  externalId?: InputMaybe<StringBoolExp>;
  externalSkuName?: InputMaybe<StringBoolExp>;
  fulfillmentStrategy?: InputMaybe<StringBoolExp>;
  id?: InputMaybe<StringBoolExp>;
  listingStrategy?: InputMaybe<StringBoolExp>;
  name?: InputMaybe<StringBoolExp>;
  qtyAvailable?: InputMaybe<Int32BoolExp>;
  qtyExpected?: InputMaybe<Int32BoolExp>;
  qtyListed?: InputMaybe<Int32BoolExp>;
  qtyReserved?: InputMaybe<Int32BoolExp>;
  reconciledAt?: InputMaybe<DateTime643BoolExp>;
  refreshedAt?: InputMaybe<DateTime643BoolExp>;
  sku?: InputMaybe<SkusBoolExp>;
  skuId?: InputMaybe<StringBoolExp>;
  skuName?: InputMaybe<StringBoolExp>;
  status?: InputMaybe<StringBoolExp>;
  updatedAt?: InputMaybe<DateTime643BoolExp>;
};

export type ListingsFilterInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ListingsOrderByExp>>;
  where?: InputMaybe<ListingsBoolExp>;
};

export type ListingsOrderByExp = {
  accountId?: InputMaybe<OrderBy>;
  channelId?: InputMaybe<OrderBy>;
  channelName?: InputMaybe<OrderBy>;
  collectionsJson?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  externalId?: InputMaybe<OrderBy>;
  externalSkuName?: InputMaybe<OrderBy>;
  fulfillmentStrategy?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  listingStrategy?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  qtyAvailable?: InputMaybe<OrderBy>;
  qtyExpected?: InputMaybe<OrderBy>;
  qtyListed?: InputMaybe<OrderBy>;
  qtyReserved?: InputMaybe<OrderBy>;
  reconciledAt?: InputMaybe<OrderBy>;
  refreshedAt?: InputMaybe<OrderBy>;
  skuId?: InputMaybe<OrderBy>;
  skuName?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

export type Locations = {
  __typename?: 'Locations';
  accountId: Scalars['String']['output'];
  address1: Scalars['String']['output'];
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country: Scalars['String']['output'];
  createdAt: Scalars['String1']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  postcode: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['String1']['output'];
  warehouseLocation?: Maybe<Locations>;
  warehouseLocationId?: Maybe<Scalars['String']['output']>;
};

export type LocationsAggExp = {
  __typename?: 'LocationsAggExp';
  _count: Scalars['Int']['output'];
  accountId: StringAggExp;
  address1: StringAggExp;
  address2: StringAggExp;
  city: StringAggExp;
  country: StringAggExp;
  createdAt: DateTime643AggExp;
  externalId: StringAggExp;
  id: StringAggExp;
  name: StringAggExp;
  postcode: StringAggExp;
  state: StringAggExp;
  status: StringAggExp;
  type: StringAggExp;
  updatedAt: DateTime643AggExp;
  warehouseLocationId: StringAggExp;
};

export type LocationsBoolExp = {
  _and?: InputMaybe<Array<LocationsBoolExp>>;
  _not?: InputMaybe<LocationsBoolExp>;
  _or?: InputMaybe<Array<LocationsBoolExp>>;
  accountId?: InputMaybe<StringBoolExp>;
  address1?: InputMaybe<StringBoolExp>;
  address2?: InputMaybe<StringBoolExp>;
  city?: InputMaybe<StringBoolExp>;
  country?: InputMaybe<StringBoolExp>;
  createdAt?: InputMaybe<DateTimeBoolExp>;
  externalId?: InputMaybe<StringBoolExp>;
  id?: InputMaybe<StringBoolExp>;
  name?: InputMaybe<StringBoolExp>;
  postcode?: InputMaybe<StringBoolExp>;
  state?: InputMaybe<StringBoolExp>;
  status?: InputMaybe<StringBoolExp>;
  type?: InputMaybe<StringBoolExp>;
  updatedAt?: InputMaybe<DateTimeBoolExp>;
  warehouseLocation?: InputMaybe<LocationsBoolExp>;
  warehouseLocationId?: InputMaybe<StringBoolExp>;
};

export type LocationsFilterInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<LocationsOrderByExp>>;
  where?: InputMaybe<LocationsBoolExp>;
};

export type LocationsOrderByExp = {
  accountId?: InputMaybe<OrderBy>;
  address1?: InputMaybe<OrderBy>;
  address2?: InputMaybe<OrderBy>;
  city?: InputMaybe<OrderBy>;
  country?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  externalId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  postcode?: InputMaybe<OrderBy>;
  state?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  warehouseLocation?: InputMaybe<LocationsOrderByExp>;
  warehouseLocationId?: InputMaybe<OrderBy>;
};

export type Mutation = {
  __typename?: 'Mutation';
  _no_fields_accessible?: Maybe<Scalars['String']['output']>;
};

export enum OrderBy {
  /** Sorts the data in ascending order */
  Asc = 'Asc',
  /** Sorts the data in descending order */
  Desc = 'Desc'
}

export type OrderHolds = {
  __typename?: 'OrderHolds';
  createdAt: Scalars['String1']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
  releasedAt?: Maybe<Scalars['String1']['output']>;
  status: Scalars['String']['output'];
  subtype?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  updatedAt: Scalars['String1']['output'];
};

export type OrderHoldsBoolExp = {
  _and?: InputMaybe<Array<OrderHoldsBoolExp>>;
  _not?: InputMaybe<OrderHoldsBoolExp>;
  _or?: InputMaybe<Array<OrderHoldsBoolExp>>;
  createdAt?: InputMaybe<DateTime643BoolExp>;
  description?: InputMaybe<StringBoolExp>;
  id?: InputMaybe<StringBoolExp>;
  orderId?: InputMaybe<StringBoolExp>;
  releasedAt?: InputMaybe<DateTime643BoolExp>;
  status?: InputMaybe<StringBoolExp>;
  subtype?: InputMaybe<StringBoolExp>;
  type?: InputMaybe<StringBoolExp>;
  updatedAt?: InputMaybe<DateTime643BoolExp>;
};

export type OrderLines = {
  __typename?: 'OrderLines';
  createdAt: Scalars['String1']['output'];
  customAttributesJson: Scalars['String']['output'];
  description: Scalars['String']['output'];
  dimensionUnit?: Maybe<Scalars['String']['output']>;
  discountAmount: Scalars['Bigdecimal']['output'];
  discountRate?: Maybe<Scalars['Bigdecimal']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  externalSkuCode?: Maybe<Scalars['String']['output']>;
  externalSkuName?: Maybe<Scalars['String']['output']>;
  fulfillmentStrategy?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Bigdecimal']['output']>;
  id: Scalars['String']['output'];
  kitComponentQty?: Maybe<Scalars['Bigdecimal']['output']>;
  kitOrderLineId?: Maybe<Scalars['String']['output']>;
  kitSkuName?: Maybe<Scalars['String']['output']>;
  lengthDimension?: Maybe<Scalars['Bigdecimal']['output']>;
  lineNumber: Scalars['Int32']['output'];
  lineTotal: Scalars['Bigdecimal']['output'];
  managedActions: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
  qtyAllocated: Scalars['Int32']['output'];
  qtyAssigned: Scalars['Int32']['output'];
  qtyBalance: Scalars['Int32']['output'];
  qtyCommitted: Scalars['Int32']['output'];
  qtyOrdered: Scalars['Int32']['output'];
  qtyReserved: Scalars['Int32']['output'];
  qtyShipped: Scalars['Int32']['output'];
  skuComponentGroupId?: Maybe<Scalars['String']['output']>;
  skuComponentGroupQty?: Maybe<Scalars['Int32']['output']>;
  skuId?: Maybe<Scalars['String']['output']>;
  skuName: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  unitPrice: Scalars['Bigdecimal']['output'];
  updatedAt: Scalars['String1']['output'];
  weight?: Maybe<Scalars['Bigdecimal']['output']>;
  weightUnit?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Bigdecimal']['output']>;
};

export type OrderLinesBoolExp = {
  _and?: InputMaybe<Array<OrderLinesBoolExp>>;
  _not?: InputMaybe<OrderLinesBoolExp>;
  _or?: InputMaybe<Array<OrderLinesBoolExp>>;
  createdAt?: InputMaybe<DateTime643BoolExp>;
  customAttributesJson?: InputMaybe<StringBoolExp>;
  description?: InputMaybe<StringBoolExp>;
  dimensionUnit?: InputMaybe<StringBoolExp>;
  discountAmount?: InputMaybe<Decimal387BoolExp>;
  discountRate?: InputMaybe<Decimal387BoolExp>;
  externalId?: InputMaybe<StringBoolExp>;
  externalSkuCode?: InputMaybe<StringBoolExp>;
  externalSkuName?: InputMaybe<StringBoolExp>;
  fulfillmentStrategy?: InputMaybe<StringBoolExp>;
  height?: InputMaybe<Decimal387BoolExp>;
  id?: InputMaybe<StringBoolExp>;
  kitComponentQty?: InputMaybe<Decimal387BoolExp>;
  kitOrderLineId?: InputMaybe<StringBoolExp>;
  kitSkuName?: InputMaybe<StringBoolExp>;
  lengthDimension?: InputMaybe<Decimal387BoolExp>;
  lineNumber?: InputMaybe<Int32BoolExp>;
  lineTotal?: InputMaybe<Decimal387BoolExp>;
  managedActions?: InputMaybe<StringBoolExp>;
  orderId?: InputMaybe<StringBoolExp>;
  qtyAllocated?: InputMaybe<Int32BoolExp>;
  qtyAssigned?: InputMaybe<Int32BoolExp>;
  qtyBalance?: InputMaybe<Int32BoolExp>;
  qtyCommitted?: InputMaybe<Int32BoolExp>;
  qtyOrdered?: InputMaybe<Int32BoolExp>;
  qtyReserved?: InputMaybe<Int32BoolExp>;
  qtyShipped?: InputMaybe<Int32BoolExp>;
  skuComponentGroupId?: InputMaybe<StringBoolExp>;
  skuComponentGroupQty?: InputMaybe<Int32BoolExp>;
  skuId?: InputMaybe<StringBoolExp>;
  skuName?: InputMaybe<StringBoolExp>;
  status?: InputMaybe<StringBoolExp>;
  unitPrice?: InputMaybe<Decimal387BoolExp>;
  updatedAt?: InputMaybe<DateTime643BoolExp>;
  weight?: InputMaybe<Decimal387BoolExp>;
  weightUnit?: InputMaybe<StringBoolExp>;
  width?: InputMaybe<Decimal387BoolExp>;
};

export type OrderProcesses = {
  __typename?: 'OrderProcesses';
  accountId: Scalars['String']['output'];
  createdAt: Scalars['String1']['output'];
  currentState: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastStartedAt?: Maybe<Scalars['String1']['output']>;
  orderId: Scalars['String']['output'];
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['String1']['output'];
};

export type OrderProcessesBoolExp = {
  _and?: InputMaybe<Array<OrderProcessesBoolExp>>;
  _not?: InputMaybe<OrderProcessesBoolExp>;
  _or?: InputMaybe<Array<OrderProcessesBoolExp>>;
  accountId?: InputMaybe<StringBoolExp>;
  createdAt?: InputMaybe<DateTime643BoolExp>;
  currentState?: InputMaybe<StringBoolExp>;
  id?: InputMaybe<StringBoolExp>;
  lastStartedAt?: InputMaybe<DateTime643BoolExp>;
  orderId?: InputMaybe<StringBoolExp>;
  status?: InputMaybe<StringBoolExp>;
  type?: InputMaybe<StringBoolExp>;
  updatedAt?: InputMaybe<DateTime643BoolExp>;
};

export type Orders = {
  __typename?: 'Orders';
  accountId: Scalars['String']['output'];
  accountName?: Maybe<Scalars['String']['output']>;
  allowPartialFulfillments: Scalars['Boolean1']['output'];
  billingAddressAddress1?: Maybe<Scalars['String']['output']>;
  billingAddressAddress2?: Maybe<Scalars['String']['output']>;
  billingAddressCity?: Maybe<Scalars['String']['output']>;
  billingAddressCompanyName?: Maybe<Scalars['String']['output']>;
  billingAddressContactEmail?: Maybe<Scalars['String']['output']>;
  billingAddressContactName?: Maybe<Scalars['String']['output']>;
  billingAddressContactNumber?: Maybe<Scalars['String']['output']>;
  billingAddressCountry?: Maybe<Scalars['String']['output']>;
  billingAddressPostcode?: Maybe<Scalars['String']['output']>;
  billingAddressState?: Maybe<Scalars['String']['output']>;
  channelId?: Maybe<Scalars['String']['output']>;
  channelName?: Maybe<Scalars['String']['output']>;
  commitmentPriorityLevel: Scalars['Int32']['output'];
  createdAt: Scalars['String1']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  customAttributesJson: Scalars['String']['output'];
  customerId?: Maybe<Scalars['String']['output']>;
  customerName: Scalars['String']['output'];
  customerOrderNumber?: Maybe<Scalars['Int32']['output']>;
  deliveryInstructions?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  externalUrl?: Maybe<Scalars['String']['output']>;
  fulfillmentProfileId?: Maybe<Scalars['String']['output']>;
  fulfillmentProfileName?: Maybe<Scalars['String']['output']>;
  fulfillmentStatus: Scalars['String']['output'];
  id: Scalars['String']['output'];
  ignoreAddressCorrection: Scalars['Boolean1']['output'];
  managedActions: Scalars['String']['output'];
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  orderHolds?: Maybe<Array<OrderHolds>>;
  orderLines?: Maybe<Array<OrderLines>>;
  orderNumber: Scalars['Int32']['output'];
  orderProcesses?: Maybe<Array<OrderProcesses>>;
  orderedAt?: Maybe<Scalars['String1']['output']>;
  packingInstructions?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  qtyAllocated: Scalars['Int32']['output'];
  qtyAssigned: Scalars['Int32']['output'];
  qtyBalance: Scalars['Int32']['output'];
  qtyCommitted: Scalars['Int32']['output'];
  qtyOrdered: Scalars['Int32']['output'];
  qtyReserved: Scalars['Int32']['output'];
  qtyShipped: Scalars['Int32']['output'];
  reference?: Maybe<Scalars['String']['output']>;
  reservationLocationId?: Maybe<Scalars['String']['output']>;
  shippingAddressAddress1: Scalars['String']['output'];
  shippingAddressAddress2?: Maybe<Scalars['String']['output']>;
  shippingAddressCity?: Maybe<Scalars['String']['output']>;
  shippingAddressCompanyName?: Maybe<Scalars['String']['output']>;
  shippingAddressContactEmail?: Maybe<Scalars['String']['output']>;
  shippingAddressContactName: Scalars['String']['output'];
  shippingAddressContactNumber?: Maybe<Scalars['String']['output']>;
  shippingAddressCountry: Scalars['String']['output'];
  shippingAddressPostcode?: Maybe<Scalars['String']['output']>;
  shippingAddressState?: Maybe<Scalars['String']['output']>;
  shippingAddressType?: Maybe<Scalars['String']['output']>;
  shippingDescription?: Maybe<Scalars['String']['output']>;
  shippingProfileId?: Maybe<Scalars['String']['output']>;
  shippingProfileName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subtotalDiscounts?: Maybe<Scalars['Bigdecimal']['output']>;
  subtotalPrice?: Maybe<Scalars['Bigdecimal']['output']>;
  subtotalShipping?: Maybe<Scalars['Bigdecimal']['output']>;
  /** Tag edges - access tags via tag relationship */
  tagEdges?: Maybe<Array<SalesOrderToTag>>;
  totalPrice?: Maybe<Scalars['Bigdecimal']['output']>;
  updatedAt: Scalars['String1']['output'];
};


export type OrdersOrderHoldsArgs = {
  where?: InputMaybe<OrderHoldsBoolExp>;
};


export type OrdersOrderLinesArgs = {
  where?: InputMaybe<OrderLinesBoolExp>;
};


export type OrdersOrderProcessesArgs = {
  where?: InputMaybe<OrderProcessesBoolExp>;
};


export type OrdersTagEdgesArgs = {
  where?: InputMaybe<SalesOrderToTagBoolExp>;
};

export type OrdersAggExp = {
  __typename?: 'OrdersAggExp';
  _count: Scalars['Int']['output'];
  accountId: StringAggExp;
  accountName: StringAggExp;
  allowPartialFulfillments: BoolAggExp;
  billingAddressAddress1: StringAggExp;
  billingAddressAddress2: StringAggExp;
  billingAddressCity: StringAggExp;
  billingAddressCompanyName: StringAggExp;
  billingAddressContactEmail: StringAggExp;
  billingAddressContactName: StringAggExp;
  billingAddressContactNumber: StringAggExp;
  billingAddressCountry: StringAggExp;
  billingAddressPostcode: StringAggExp;
  billingAddressState: StringAggExp;
  channelId: StringAggExp;
  channelName: StringAggExp;
  commitmentPriorityLevel: Int32AggExp;
  createdAt: DateTime643AggExp;
  currency: StringAggExp;
  customAttributesJson: StringAggExp;
  customerId: StringAggExp;
  customerName: StringAggExp;
  customerOrderNumber: Int32AggExp;
  deliveryInstructions: StringAggExp;
  email: StringAggExp;
  externalId: StringAggExp;
  externalUrl: StringAggExp;
  fulfillmentProfileId: StringAggExp;
  fulfillmentProfileName: StringAggExp;
  fulfillmentStatus: StringAggExp;
  id: StringAggExp;
  ignoreAddressCorrection: BoolAggExp;
  managedActions: StringAggExp;
  name: StringAggExp;
  notes: StringAggExp;
  orderNumber: Int32AggExp;
  orderedAt: DateTime643AggExp;
  packingInstructions: StringAggExp;
  phone: StringAggExp;
  qtyAllocated: Int32AggExp;
  qtyAssigned: Int32AggExp;
  qtyBalance: Int32AggExp;
  qtyCommitted: Int32AggExp;
  qtyOrdered: Int32AggExp;
  qtyReserved: Int32AggExp;
  qtyShipped: Int32AggExp;
  reference: StringAggExp;
  reservationLocationId: StringAggExp;
  shippingAddressAddress1: StringAggExp;
  shippingAddressAddress2: StringAggExp;
  shippingAddressCity: StringAggExp;
  shippingAddressCompanyName: StringAggExp;
  shippingAddressContactEmail: StringAggExp;
  shippingAddressContactName: StringAggExp;
  shippingAddressContactNumber: StringAggExp;
  shippingAddressCountry: StringAggExp;
  shippingAddressPostcode: StringAggExp;
  shippingAddressState: StringAggExp;
  shippingAddressType: StringAggExp;
  shippingDescription: StringAggExp;
  shippingProfileId: StringAggExp;
  shippingProfileName: StringAggExp;
  status: StringAggExp;
  subtotalDiscounts: Decimal387AggExp;
  subtotalPrice: Decimal387AggExp;
  subtotalShipping: Decimal387AggExp;
  totalPrice: Decimal387AggExp;
  updatedAt: DateTime643AggExp;
};

export type OrdersBoolExp = {
  _and?: InputMaybe<Array<OrdersBoolExp>>;
  _not?: InputMaybe<OrdersBoolExp>;
  _or?: InputMaybe<Array<OrdersBoolExp>>;
  accountId?: InputMaybe<StringBoolExp>;
  accountName?: InputMaybe<StringBoolExp>;
  allowPartialFulfillments?: InputMaybe<BoolBoolExp>;
  billingAddressAddress1?: InputMaybe<StringBoolExp>;
  billingAddressAddress2?: InputMaybe<StringBoolExp>;
  billingAddressCity?: InputMaybe<StringBoolExp>;
  billingAddressCompanyName?: InputMaybe<StringBoolExp>;
  billingAddressContactEmail?: InputMaybe<StringBoolExp>;
  billingAddressContactName?: InputMaybe<StringBoolExp>;
  billingAddressContactNumber?: InputMaybe<StringBoolExp>;
  billingAddressCountry?: InputMaybe<StringBoolExp>;
  billingAddressPostcode?: InputMaybe<StringBoolExp>;
  billingAddressState?: InputMaybe<StringBoolExp>;
  channelId?: InputMaybe<StringBoolExp>;
  channelName?: InputMaybe<StringBoolExp>;
  commitmentPriorityLevel?: InputMaybe<Int32BoolExp>;
  createdAt?: InputMaybe<DateTime643BoolExp>;
  currency?: InputMaybe<StringBoolExp>;
  customAttributesJson?: InputMaybe<StringBoolExp>;
  customerId?: InputMaybe<StringBoolExp>;
  customerName?: InputMaybe<StringBoolExp>;
  customerOrderNumber?: InputMaybe<Int32BoolExp>;
  deliveryInstructions?: InputMaybe<StringBoolExp>;
  email?: InputMaybe<StringBoolExp>;
  externalId?: InputMaybe<StringBoolExp>;
  externalUrl?: InputMaybe<StringBoolExp>;
  fulfillmentProfileId?: InputMaybe<StringBoolExp>;
  fulfillmentProfileName?: InputMaybe<StringBoolExp>;
  fulfillmentStatus?: InputMaybe<StringBoolExp>;
  id?: InputMaybe<StringBoolExp>;
  ignoreAddressCorrection?: InputMaybe<BoolBoolExp>;
  managedActions?: InputMaybe<StringBoolExp>;
  name?: InputMaybe<StringBoolExp>;
  notes?: InputMaybe<StringBoolExp>;
  orderHolds?: InputMaybe<OrderHoldsBoolExp>;
  orderLines?: InputMaybe<OrderLinesBoolExp>;
  orderNumber?: InputMaybe<Int32BoolExp>;
  orderProcesses?: InputMaybe<OrderProcessesBoolExp>;
  orderedAt?: InputMaybe<DateTime643BoolExp>;
  packingInstructions?: InputMaybe<StringBoolExp>;
  phone?: InputMaybe<StringBoolExp>;
  qtyAllocated?: InputMaybe<Int32BoolExp>;
  qtyAssigned?: InputMaybe<Int32BoolExp>;
  qtyBalance?: InputMaybe<Int32BoolExp>;
  qtyCommitted?: InputMaybe<Int32BoolExp>;
  qtyOrdered?: InputMaybe<Int32BoolExp>;
  qtyReserved?: InputMaybe<Int32BoolExp>;
  qtyShipped?: InputMaybe<Int32BoolExp>;
  reference?: InputMaybe<StringBoolExp>;
  reservationLocationId?: InputMaybe<StringBoolExp>;
  shippingAddressAddress1?: InputMaybe<StringBoolExp>;
  shippingAddressAddress2?: InputMaybe<StringBoolExp>;
  shippingAddressCity?: InputMaybe<StringBoolExp>;
  shippingAddressCompanyName?: InputMaybe<StringBoolExp>;
  shippingAddressContactEmail?: InputMaybe<StringBoolExp>;
  shippingAddressContactName?: InputMaybe<StringBoolExp>;
  shippingAddressContactNumber?: InputMaybe<StringBoolExp>;
  shippingAddressCountry?: InputMaybe<StringBoolExp>;
  shippingAddressPostcode?: InputMaybe<StringBoolExp>;
  shippingAddressState?: InputMaybe<StringBoolExp>;
  shippingAddressType?: InputMaybe<StringBoolExp>;
  shippingDescription?: InputMaybe<StringBoolExp>;
  shippingProfileId?: InputMaybe<StringBoolExp>;
  shippingProfileName?: InputMaybe<StringBoolExp>;
  status?: InputMaybe<StringBoolExp>;
  subtotalDiscounts?: InputMaybe<Decimal387BoolExp>;
  subtotalPrice?: InputMaybe<Decimal387BoolExp>;
  subtotalShipping?: InputMaybe<Decimal387BoolExp>;
  tagEdges?: InputMaybe<SalesOrderToTagBoolExp>;
  totalPrice?: InputMaybe<Decimal387BoolExp>;
  updatedAt?: InputMaybe<DateTime643BoolExp>;
};

export type OrdersFilterInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<OrdersOrderByExp>>;
  where?: InputMaybe<OrdersBoolExp>;
};

export type OrdersOrderByExp = {
  accountId?: InputMaybe<OrderBy>;
  accountName?: InputMaybe<OrderBy>;
  allowPartialFulfillments?: InputMaybe<OrderBy>;
  billingAddressAddress1?: InputMaybe<OrderBy>;
  billingAddressAddress2?: InputMaybe<OrderBy>;
  billingAddressCity?: InputMaybe<OrderBy>;
  billingAddressCompanyName?: InputMaybe<OrderBy>;
  billingAddressContactEmail?: InputMaybe<OrderBy>;
  billingAddressContactName?: InputMaybe<OrderBy>;
  billingAddressContactNumber?: InputMaybe<OrderBy>;
  billingAddressCountry?: InputMaybe<OrderBy>;
  billingAddressPostcode?: InputMaybe<OrderBy>;
  billingAddressState?: InputMaybe<OrderBy>;
  channelId?: InputMaybe<OrderBy>;
  channelName?: InputMaybe<OrderBy>;
  commitmentPriorityLevel?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  customAttributesJson?: InputMaybe<OrderBy>;
  customerId?: InputMaybe<OrderBy>;
  customerName?: InputMaybe<OrderBy>;
  customerOrderNumber?: InputMaybe<OrderBy>;
  deliveryInstructions?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  externalId?: InputMaybe<OrderBy>;
  externalUrl?: InputMaybe<OrderBy>;
  fulfillmentProfileId?: InputMaybe<OrderBy>;
  fulfillmentProfileName?: InputMaybe<OrderBy>;
  fulfillmentStatus?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  ignoreAddressCorrection?: InputMaybe<OrderBy>;
  managedActions?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  notes?: InputMaybe<OrderBy>;
  orderNumber?: InputMaybe<OrderBy>;
  orderedAt?: InputMaybe<OrderBy>;
  packingInstructions?: InputMaybe<OrderBy>;
  phone?: InputMaybe<OrderBy>;
  qtyAllocated?: InputMaybe<OrderBy>;
  qtyAssigned?: InputMaybe<OrderBy>;
  qtyBalance?: InputMaybe<OrderBy>;
  qtyCommitted?: InputMaybe<OrderBy>;
  qtyOrdered?: InputMaybe<OrderBy>;
  qtyReserved?: InputMaybe<OrderBy>;
  qtyShipped?: InputMaybe<OrderBy>;
  reference?: InputMaybe<OrderBy>;
  reservationLocationId?: InputMaybe<OrderBy>;
  shippingAddressAddress1?: InputMaybe<OrderBy>;
  shippingAddressAddress2?: InputMaybe<OrderBy>;
  shippingAddressCity?: InputMaybe<OrderBy>;
  shippingAddressCompanyName?: InputMaybe<OrderBy>;
  shippingAddressContactEmail?: InputMaybe<OrderBy>;
  shippingAddressContactName?: InputMaybe<OrderBy>;
  shippingAddressContactNumber?: InputMaybe<OrderBy>;
  shippingAddressCountry?: InputMaybe<OrderBy>;
  shippingAddressPostcode?: InputMaybe<OrderBy>;
  shippingAddressState?: InputMaybe<OrderBy>;
  shippingAddressType?: InputMaybe<OrderBy>;
  shippingDescription?: InputMaybe<OrderBy>;
  shippingProfileId?: InputMaybe<OrderBy>;
  shippingProfileName?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  subtotalDiscounts?: InputMaybe<OrderBy>;
  subtotalPrice?: InputMaybe<OrderBy>;
  subtotalShipping?: InputMaybe<OrderBy>;
  totalPrice?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

export type Query = {
  __typename?: 'Query';
  accounts?: Maybe<Array<Accounts>>;
  accountsAggregate?: Maybe<AccountsAggExp>;
  asns?: Maybe<Array<Asns>>;
  asnsAggregate?: Maybe<AsnsAggExp>;
  bills?: Maybe<Array<Bills>>;
  billsAggregate?: Maybe<BillsAggExp>;
  channels?: Maybe<Array<Channels>>;
  channelsAggregate?: Maybe<ChannelsAggExp>;
  inventories?: Maybe<Array<Inventories>>;
  inventoriesAggregate?: Maybe<InventoriesAggExp>;
  listings?: Maybe<Array<Listings>>;
  listingsAggregate?: Maybe<ListingsAggExp>;
  locations?: Maybe<Array<Locations>>;
  locationsAggregate?: Maybe<LocationsAggExp>;
  orders?: Maybe<Array<Orders>>;
  ordersAggregate?: Maybe<OrdersAggExp>;
  returns?: Maybe<Array<Returns>>;
  returnsAggregate?: Maybe<ReturnsAggExp>;
  skus?: Maybe<Array<Skus>>;
  skusAggregate?: Maybe<SkusAggExp>;
  tags?: Maybe<Array<Tags>>;
  tagsAggregate?: Maybe<TagsAggExp>;
  workflows?: Maybe<Array<AutomationWorkflows>>;
  workflowsAggregate?: Maybe<AutomationWorkflowsAggExp>;
};


export type QueryAccountsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AccountsOrderByExp>>;
  where?: InputMaybe<AccountsBoolExp>;
};


export type QueryAccountsAggregateArgs = {
  filter_input?: InputMaybe<AccountsFilterInput>;
};


export type QueryAsnsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AsnsOrderByExp>>;
  where?: InputMaybe<AsnsBoolExp>;
};


export type QueryAsnsAggregateArgs = {
  filter_input?: InputMaybe<AsnsFilterInput>;
};


export type QueryBillsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BillsOrderByExp>>;
  where?: InputMaybe<BillsBoolExp>;
};


export type QueryBillsAggregateArgs = {
  filter_input?: InputMaybe<BillsFilterInput>;
};


export type QueryChannelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ChannelsOrderByExp>>;
  where?: InputMaybe<ChannelsBoolExp>;
};


export type QueryChannelsAggregateArgs = {
  filter_input?: InputMaybe<ChannelsFilterInput>;
};


export type QueryInventoriesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InventoriesOrderByExp>>;
  where?: InputMaybe<InventoriesBoolExp>;
};


export type QueryInventoriesAggregateArgs = {
  filter_input?: InputMaybe<InventoriesFilterInput>;
};


export type QueryListingsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ListingsOrderByExp>>;
  where?: InputMaybe<ListingsBoolExp>;
};


export type QueryListingsAggregateArgs = {
  filter_input?: InputMaybe<ListingsFilterInput>;
};


export type QueryLocationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<LocationsOrderByExp>>;
  where?: InputMaybe<LocationsBoolExp>;
};


export type QueryLocationsAggregateArgs = {
  filter_input?: InputMaybe<LocationsFilterInput>;
};


export type QueryOrdersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<OrdersOrderByExp>>;
  where?: InputMaybe<OrdersBoolExp>;
};


export type QueryOrdersAggregateArgs = {
  filter_input?: InputMaybe<OrdersFilterInput>;
};


export type QueryReturnsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ReturnsOrderByExp>>;
  where?: InputMaybe<ReturnsBoolExp>;
};


export type QueryReturnsAggregateArgs = {
  filter_input?: InputMaybe<ReturnsFilterInput>;
};


export type QuerySkusArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SkusOrderByExp>>;
  where?: InputMaybe<SkusBoolExp>;
};


export type QuerySkusAggregateArgs = {
  filter_input?: InputMaybe<SkusFilterInput>;
};


export type QueryTagsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TagsOrderByExp>>;
  where?: InputMaybe<TagsBoolExp>;
};


export type QueryTagsAggregateArgs = {
  filter_input?: InputMaybe<TagsFilterInput>;
};


export type QueryWorkflowsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AutomationWorkflowsOrderByExp>>;
  where?: InputMaybe<AutomationWorkflowsBoolExp>;
};


export type QueryWorkflowsAggregateArgs = {
  filter_input?: InputMaybe<WorkflowsFilterInput>;
};

export type ReturnLines = {
  __typename?: 'ReturnLines';
  createdAt: Scalars['String1']['output'];
  customAttributesJson: Scalars['String']['output'];
  description: Scalars['String']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  externalSkuName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lineNumber: Scalars['Int32']['output'];
  qtyExpected: Scalars['Int32']['output'];
  qtyReceived: Scalars['Int32']['output'];
  returnId: Scalars['String']['output'];
  skuId: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['String1']['output'];
};

export type ReturnLinesBoolExp = {
  _and?: InputMaybe<Array<ReturnLinesBoolExp>>;
  _not?: InputMaybe<ReturnLinesBoolExp>;
  _or?: InputMaybe<Array<ReturnLinesBoolExp>>;
  createdAt?: InputMaybe<DateTime643BoolExp>;
  customAttributesJson?: InputMaybe<StringBoolExp>;
  description?: InputMaybe<StringBoolExp>;
  externalId?: InputMaybe<StringBoolExp>;
  externalSkuName?: InputMaybe<StringBoolExp>;
  id?: InputMaybe<StringBoolExp>;
  lineNumber?: InputMaybe<Int32BoolExp>;
  qtyExpected?: InputMaybe<Int32BoolExp>;
  qtyReceived?: InputMaybe<Int32BoolExp>;
  returnId?: InputMaybe<StringBoolExp>;
  skuId?: InputMaybe<StringBoolExp>;
  status?: InputMaybe<StringBoolExp>;
  updatedAt?: InputMaybe<DateTime643BoolExp>;
};

export type Returns = {
  __typename?: 'Returns';
  accountId: Scalars['String']['output'];
  attachmentsJson?: Maybe<Scalars['String']['output']>;
  carrier?: Maybe<Scalars['String']['output']>;
  closedAt: Scalars['String1']['output'];
  createdAt: Scalars['String1']['output'];
  customAttributesJson: Scalars['String']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  externalNote?: Maybe<Scalars['String']['output']>;
  fromAddressAddress1?: Maybe<Scalars['String']['output']>;
  fromAddressAddress2?: Maybe<Scalars['String']['output']>;
  fromAddressCity?: Maybe<Scalars['String']['output']>;
  fromAddressCompanyName?: Maybe<Scalars['String']['output']>;
  fromAddressContactEmail?: Maybe<Scalars['String']['output']>;
  fromAddressContactName?: Maybe<Scalars['String']['output']>;
  fromAddressContactNumber?: Maybe<Scalars['String']['output']>;
  fromAddressCountry?: Maybe<Scalars['String']['output']>;
  fromAddressPostcode?: Maybe<Scalars['String']['output']>;
  fromAddressState?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  internalNote?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Locations>;
  locationId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  order?: Maybe<Orders>;
  orderId?: Maybe<Scalars['String']['output']>;
  parcelType?: Maybe<Scalars['String']['output']>;
  qtyExpected: Scalars['Int32']['output'];
  qtyReceived: Scalars['Int32']['output'];
  receiptStatus: Scalars['String']['output'];
  reference?: Maybe<Scalars['String']['output']>;
  returnCategory: Scalars['String']['output'];
  returnLines?: Maybe<Array<ReturnLines>>;
  returnNumber: Scalars['Int32']['output'];
  status: Scalars['String']['output'];
  trackingNumber?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String1']['output'];
  warehouseLocationId?: Maybe<Scalars['String']['output']>;
};


export type ReturnsReturnLinesArgs = {
  where?: InputMaybe<ReturnLinesBoolExp>;
};

export type ReturnsAggExp = {
  __typename?: 'ReturnsAggExp';
  _count: Scalars['Int']['output'];
  accountId: StringAggExp;
  attachmentsJson: StringAggExp;
  carrier: StringAggExp;
  closedAt: DateTime643AggExp;
  createdAt: DateTime643AggExp;
  customAttributesJson: StringAggExp;
  externalId: StringAggExp;
  externalNote: StringAggExp;
  fromAddressAddress1: StringAggExp;
  fromAddressAddress2: StringAggExp;
  fromAddressCity: StringAggExp;
  fromAddressCompanyName: StringAggExp;
  fromAddressContactEmail: StringAggExp;
  fromAddressContactName: StringAggExp;
  fromAddressContactNumber: StringAggExp;
  fromAddressCountry: StringAggExp;
  fromAddressPostcode: StringAggExp;
  fromAddressState: StringAggExp;
  id: StringAggExp;
  internalNote: StringAggExp;
  locationId: StringAggExp;
  name: StringAggExp;
  orderId: StringAggExp;
  parcelType: StringAggExp;
  qtyExpected: Int32AggExp;
  qtyReceived: Int32AggExp;
  receiptStatus: StringAggExp;
  reference: StringAggExp;
  returnCategory: StringAggExp;
  returnNumber: Int32AggExp;
  status: StringAggExp;
  trackingNumber: StringAggExp;
  updatedAt: DateTime643AggExp;
  warehouseLocationId: StringAggExp;
};

export type ReturnsBoolExp = {
  _and?: InputMaybe<Array<ReturnsBoolExp>>;
  _not?: InputMaybe<ReturnsBoolExp>;
  _or?: InputMaybe<Array<ReturnsBoolExp>>;
  accountId?: InputMaybe<StringBoolExp>;
  attachmentsJson?: InputMaybe<StringBoolExp>;
  carrier?: InputMaybe<StringBoolExp>;
  closedAt?: InputMaybe<DateTime643BoolExp>;
  createdAt?: InputMaybe<DateTime643BoolExp>;
  customAttributesJson?: InputMaybe<StringBoolExp>;
  externalId?: InputMaybe<StringBoolExp>;
  externalNote?: InputMaybe<StringBoolExp>;
  fromAddressAddress1?: InputMaybe<StringBoolExp>;
  fromAddressAddress2?: InputMaybe<StringBoolExp>;
  fromAddressCity?: InputMaybe<StringBoolExp>;
  fromAddressCompanyName?: InputMaybe<StringBoolExp>;
  fromAddressContactEmail?: InputMaybe<StringBoolExp>;
  fromAddressContactName?: InputMaybe<StringBoolExp>;
  fromAddressContactNumber?: InputMaybe<StringBoolExp>;
  fromAddressCountry?: InputMaybe<StringBoolExp>;
  fromAddressPostcode?: InputMaybe<StringBoolExp>;
  fromAddressState?: InputMaybe<StringBoolExp>;
  id?: InputMaybe<StringBoolExp>;
  internalNote?: InputMaybe<StringBoolExp>;
  location?: InputMaybe<LocationsBoolExp>;
  locationId?: InputMaybe<StringBoolExp>;
  name?: InputMaybe<StringBoolExp>;
  order?: InputMaybe<OrdersBoolExp>;
  orderId?: InputMaybe<StringBoolExp>;
  parcelType?: InputMaybe<StringBoolExp>;
  qtyExpected?: InputMaybe<Int32BoolExp>;
  qtyReceived?: InputMaybe<Int32BoolExp>;
  receiptStatus?: InputMaybe<StringBoolExp>;
  reference?: InputMaybe<StringBoolExp>;
  returnCategory?: InputMaybe<StringBoolExp>;
  returnLines?: InputMaybe<ReturnLinesBoolExp>;
  returnNumber?: InputMaybe<Int32BoolExp>;
  status?: InputMaybe<StringBoolExp>;
  trackingNumber?: InputMaybe<StringBoolExp>;
  updatedAt?: InputMaybe<DateTime643BoolExp>;
  warehouseLocationId?: InputMaybe<StringBoolExp>;
};

export type ReturnsFilterInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ReturnsOrderByExp>>;
  where?: InputMaybe<ReturnsBoolExp>;
};

export type ReturnsOrderByExp = {
  accountId?: InputMaybe<OrderBy>;
  attachmentsJson?: InputMaybe<OrderBy>;
  carrier?: InputMaybe<OrderBy>;
  closedAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  customAttributesJson?: InputMaybe<OrderBy>;
  externalId?: InputMaybe<OrderBy>;
  externalNote?: InputMaybe<OrderBy>;
  fromAddressAddress1?: InputMaybe<OrderBy>;
  fromAddressAddress2?: InputMaybe<OrderBy>;
  fromAddressCity?: InputMaybe<OrderBy>;
  fromAddressCompanyName?: InputMaybe<OrderBy>;
  fromAddressContactEmail?: InputMaybe<OrderBy>;
  fromAddressContactName?: InputMaybe<OrderBy>;
  fromAddressContactNumber?: InputMaybe<OrderBy>;
  fromAddressCountry?: InputMaybe<OrderBy>;
  fromAddressPostcode?: InputMaybe<OrderBy>;
  fromAddressState?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  internalNote?: InputMaybe<OrderBy>;
  location?: InputMaybe<LocationsOrderByExp>;
  locationId?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  order?: InputMaybe<OrdersOrderByExp>;
  orderId?: InputMaybe<OrderBy>;
  parcelType?: InputMaybe<OrderBy>;
  qtyExpected?: InputMaybe<OrderBy>;
  qtyReceived?: InputMaybe<OrderBy>;
  receiptStatus?: InputMaybe<OrderBy>;
  reference?: InputMaybe<OrderBy>;
  returnCategory?: InputMaybe<OrderBy>;
  returnNumber?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  trackingNumber?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  warehouseLocationId?: InputMaybe<OrderBy>;
};

export type SalesOrderToTag = {
  __typename?: 'SalesOrderToTag';
  order?: Maybe<Orders>;
  orderId: Scalars['String']['output'];
  tag?: Maybe<Tags>;
  tagId: Scalars['String']['output'];
};

export type SalesOrderToTagBoolExp = {
  _and?: InputMaybe<Array<SalesOrderToTagBoolExp>>;
  _not?: InputMaybe<SalesOrderToTagBoolExp>;
  _or?: InputMaybe<Array<SalesOrderToTagBoolExp>>;
  order?: InputMaybe<OrdersBoolExp>;
  orderId?: InputMaybe<StringBoolExp>;
  tag?: InputMaybe<TagsBoolExp>;
  tagId?: InputMaybe<StringBoolExp>;
};

export type Skus = {
  __typename?: 'Skus';
  accountId: Scalars['String']['output'];
  archivedAt?: Maybe<Scalars['String1']['output']>;
  barcode: Scalars['String']['output'];
  countryOfOrigin?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String1']['output'];
  description: Scalars['String']['output'];
  dimensionUnit?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  externalSkuName?: Maybe<Scalars['String']['output']>;
  fulfillmentStrategy: Scalars['String']['output'];
  height?: Maybe<Scalars['Bigdecimal']['output']>;
  hsCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  inventories?: Maybe<Array<Inventories>>;
  length?: Maybe<Scalars['Bigdecimal']['output']>;
  name: Scalars['String']['output'];
  purchasePrice: Scalars['Bigdecimal']['output'];
  sellPrice: Scalars['Bigdecimal']['output'];
  skuVersion: Scalars['Int32']['output'];
  type: Scalars['String']['output'];
  unitOfMeasure: Scalars['String']['output'];
  unitType: Scalars['String']['output'];
  updatedAt: Scalars['String1']['output'];
  weight?: Maybe<Scalars['Bigdecimal']['output']>;
  weightUnit?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Bigdecimal']['output']>;
};


export type SkusInventoriesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InventoriesOrderByExp>>;
  where?: InputMaybe<InventoriesBoolExp>;
};

export type SkusAggExp = {
  __typename?: 'SkusAggExp';
  _count: Scalars['Int']['output'];
  accountId: StringAggExp;
  archivedAt: DateTime643AggExp;
  barcode: StringAggExp;
  countryOfOrigin: StringAggExp;
  createdAt: DateTime643AggExp;
  description: StringAggExp;
  dimensionUnit: StringAggExp;
  externalId: StringAggExp;
  externalSkuName: StringAggExp;
  fulfillmentStrategy: StringAggExp;
  height: Decimal387AggExp;
  hsCode: StringAggExp;
  id: StringAggExp;
  length: Decimal387AggExp;
  name: StringAggExp;
  purchasePrice: Decimal387AggExp;
  sellPrice: Decimal387AggExp;
  skuVersion: Int32AggExp;
  type: StringAggExp;
  unitOfMeasure: StringAggExp;
  unitType: StringAggExp;
  updatedAt: DateTime643AggExp;
  weight: Decimal387AggExp;
  weightUnit: StringAggExp;
  width: Decimal387AggExp;
};

export type SkusBoolExp = {
  _and?: InputMaybe<Array<SkusBoolExp>>;
  _not?: InputMaybe<SkusBoolExp>;
  _or?: InputMaybe<Array<SkusBoolExp>>;
  accountId?: InputMaybe<StringBoolExp>;
  archivedAt?: InputMaybe<DateTimeBoolExp>;
  barcode?: InputMaybe<StringBoolExp>;
  countryOfOrigin?: InputMaybe<StringBoolExp>;
  createdAt?: InputMaybe<DateTimeBoolExp>;
  description?: InputMaybe<StringBoolExp>;
  dimensionUnit?: InputMaybe<StringBoolExp>;
  externalId?: InputMaybe<StringBoolExp>;
  externalSkuName?: InputMaybe<StringBoolExp>;
  fulfillmentStrategy?: InputMaybe<StringBoolExp>;
  height?: InputMaybe<Decimal387BoolExp>;
  hsCode?: InputMaybe<StringBoolExp>;
  id?: InputMaybe<StringBoolExp>;
  length?: InputMaybe<Decimal387BoolExp>;
  name?: InputMaybe<StringBoolExp>;
  purchasePrice?: InputMaybe<Decimal387BoolExp>;
  sellPrice?: InputMaybe<Decimal387BoolExp>;
  skuVersion?: InputMaybe<Int32BoolExp>;
  type?: InputMaybe<StringBoolExp>;
  unitOfMeasure?: InputMaybe<StringBoolExp>;
  unitType?: InputMaybe<StringBoolExp>;
  updatedAt?: InputMaybe<DateTimeBoolExp>;
  weight?: InputMaybe<Decimal387BoolExp>;
  weightUnit?: InputMaybe<StringBoolExp>;
  width?: InputMaybe<Decimal387BoolExp>;
};

export type SkusFilterInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SkusOrderByExp>>;
  where?: InputMaybe<SkusBoolExp>;
};

export type SkusOrderByExp = {
  accountId?: InputMaybe<OrderBy>;
  archivedAt?: InputMaybe<OrderBy>;
  barcode?: InputMaybe<OrderBy>;
  countryOfOrigin?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  dimensionUnit?: InputMaybe<OrderBy>;
  externalId?: InputMaybe<OrderBy>;
  externalSkuName?: InputMaybe<OrderBy>;
  fulfillmentStrategy?: InputMaybe<OrderBy>;
  height?: InputMaybe<OrderBy>;
  hsCode?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  length?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  purchasePrice?: InputMaybe<OrderBy>;
  sellPrice?: InputMaybe<OrderBy>;
  skuVersion?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  unitOfMeasure?: InputMaybe<OrderBy>;
  unitType?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  weight?: InputMaybe<OrderBy>;
  weightUnit?: InputMaybe<OrderBy>;
  width?: InputMaybe<OrderBy>;
};

export type StringAggExp = {
  __typename?: 'StringAggExp';
  _count: Scalars['Int']['output'];
  _count_distinct: Scalars['Int']['output'];
};

export type StringBoolExp = {
  _and?: InputMaybe<Array<StringBoolExp>>;
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _match?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  _nlike?: InputMaybe<Scalars['String']['input']>;
  _not?: InputMaybe<StringBoolExp>;
  _or?: InputMaybe<Array<StringBoolExp>>;
};

export type Subscription = {
  __typename?: 'Subscription';
  _no_fields_accessible?: Maybe<Scalars['String']['output']>;
};

export type Tags = {
  __typename?: 'Tags';
  accountId: Scalars['String']['output'];
  createdAt: Scalars['String1']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** Order edges - access orders via order relationship */
  orderEdges?: Maybe<Array<SalesOrderToTag>>;
  type: Scalars['String']['output'];
  updatedAt: Scalars['String1']['output'];
};


export type TagsOrderEdgesArgs = {
  where?: InputMaybe<SalesOrderToTagBoolExp>;
};

export type TagsAggExp = {
  __typename?: 'TagsAggExp';
  _count: Scalars['Int']['output'];
  accountId: StringAggExp;
  createdAt: DateTime643AggExp;
  id: StringAggExp;
  name: StringAggExp;
  type: StringAggExp;
  updatedAt: DateTime643AggExp;
};

export type TagsBoolExp = {
  _and?: InputMaybe<Array<TagsBoolExp>>;
  _not?: InputMaybe<TagsBoolExp>;
  _or?: InputMaybe<Array<TagsBoolExp>>;
  accountId?: InputMaybe<StringBoolExp>;
  createdAt?: InputMaybe<DateTime643BoolExp>;
  id?: InputMaybe<StringBoolExp>;
  name?: InputMaybe<StringBoolExp>;
  orderEdges?: InputMaybe<SalesOrderToTagBoolExp>;
  type?: InputMaybe<StringBoolExp>;
  updatedAt?: InputMaybe<DateTime643BoolExp>;
};

export type TagsFilterInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TagsOrderByExp>>;
  where?: InputMaybe<TagsBoolExp>;
};

export type TagsOrderByExp = {
  accountId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

export type WorkflowsFilterInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AutomationWorkflowsOrderByExp>>;
  where?: InputMaybe<AutomationWorkflowsBoolExp>;
};

export type InventoriesQueryQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  where: InventoriesBoolExp;
  orderBy: Array<InventoriesOrderByExp> | InventoriesOrderByExp;
}>;


export type InventoriesQueryQuery = { __typename?: 'Query', inventories?: Array<{ __typename?: 'Inventories', id: string, skuId: string, skuName?: string | null, skuDescription?: string | null, locationId: string, locationName?: string | null, status: string, qtyExpected: number, qtyOnHand: number, qtyReserved: number, qtyAvailable: number, sku?: { __typename?: 'Skus', archivedAt?: string | null } | null }> | null, inventoriesAggregate?: { __typename?: 'InventoriesAggExp', _count: number } | null };

export type SkusQueryQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  where: SkusBoolExp;
  orderBy: Array<SkusOrderByExp> | SkusOrderByExp;
}>;


export type SkusQueryQuery = { __typename?: 'Query', skus?: Array<{ __typename?: 'Skus', id: string, name: string, description: string, barcode: string, type: string, height?: number | null, width?: number | null, length?: number | null, dimensionUnit?: string | null, weight?: number | null, weightUnit?: string | null, archivedAt?: string | null }> | null, skusAggregate?: { __typename?: 'SkusAggExp', _count: number } | null };

export type OrdersQueryQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  where: OrdersBoolExp;
  orderBy: Array<OrdersOrderByExp> | OrdersOrderByExp;
}>;


export type OrdersQueryQuery = { __typename?: 'Query', orders?: Array<{ __typename?: 'Orders', id: string, name: string, reference?: string | null, accountId: string, status?: string | null, currency?: string | null, channelId?: string | null, channelName?: string | null, customerName: string, qtyOrdered: number, totalPrice?: number | null, createdAt: string, orderedAt?: string | null, orderHolds?: Array<{ __typename?: 'OrderHolds', id: string, type: string, subtype?: string | null, description?: string | null, createdAt: string }> | null }> | null, ordersAggregate?: { __typename?: 'OrdersAggExp', _count: number } | null };

export type ListingsQueryQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  where: ListingsBoolExp;
  orderBy: Array<ListingsOrderByExp> | ListingsOrderByExp;
}>;


export type ListingsQueryQuery = { __typename?: 'Query', listings?: Array<{ __typename?: 'Listings', id: string, name: string, description: string, externalSkuName?: string | null, status: string, qtyExpected: number, qtyAvailable: number, listingStrategy: string, qtyListed: number, channelName: string, createdAt: string, updatedAt: string }> | null, listingsAggregate?: { __typename?: 'ListingsAggExp', _count: number } | null };

export type AsnsQueryQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  where: AsnsBoolExp;
  orderBy: Array<AsnsOrderByExp> | AsnsOrderByExp;
}>;


export type AsnsQueryQuery = { __typename?: 'Query', asns?: Array<{ __typename?: 'Asns', id: string, name: string, reference?: string | null, expectedAt?: string | null, locationName?: string | null, status: string, qtyExpected?: number | null, qtyReceived?: number | null, closedAt: string, createdAt: string }> | null, asnsAggregate?: { __typename?: 'AsnsAggExp', _count: number } | null };

export type ReturnsQueryQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  where: ReturnsBoolExp;
  orderBy: Array<ReturnsOrderByExp> | ReturnsOrderByExp;
}>;


export type ReturnsQueryQuery = { __typename?: 'Query', returns?: Array<{ __typename?: 'Returns', id: string, name: string, status: string, returnCategory: string, createdAt: string, closedAt: string, fromAddressContactName?: string | null, order?: { __typename?: 'Orders', name: string } | null, location?: { __typename?: 'Locations', name: string } | null }> | null, returnsAggregate?: { __typename?: 'ReturnsAggExp', _count: number } | null };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const InventoriesQueryDocument = new TypedDocumentString(`
    query InventoriesQuery($limit: Int!, $offset: Int!, $where: InventoriesBoolExp!, $orderBy: [InventoriesOrderByExp!]!) {
  inventories(limit: $limit, offset: $offset, where: $where, order_by: $orderBy) {
    id
    skuId
    skuName
    skuDescription
    locationId
    locationName
    status
    qtyExpected
    qtyOnHand
    qtyReserved
    qtyAvailable
    sku {
      archivedAt
    }
  }
  inventoriesAggregate(filter_input: {where: $where}) {
    _count
  }
}
    `) as unknown as TypedDocumentString<InventoriesQueryQuery, InventoriesQueryQueryVariables>;
export const SkusQueryDocument = new TypedDocumentString(`
    query SkusQuery($limit: Int!, $offset: Int!, $where: SkusBoolExp!, $orderBy: [SkusOrderByExp!]!) {
  skus(limit: $limit, offset: $offset, where: $where, order_by: $orderBy) {
    id
    name
    description
    barcode
    type
    height
    width
    length
    dimensionUnit
    weight
    weightUnit
    archivedAt
  }
  skusAggregate(filter_input: {where: $where}) {
    _count
  }
}
    `) as unknown as TypedDocumentString<SkusQueryQuery, SkusQueryQueryVariables>;
export const OrdersQueryDocument = new TypedDocumentString(`
    query OrdersQuery($limit: Int!, $offset: Int!, $where: OrdersBoolExp!, $orderBy: [OrdersOrderByExp!]!) {
  orders(limit: $limit, offset: $offset, where: $where, order_by: $orderBy) {
    id
    name
    reference
    accountId
    status
    currency
    channelId
    channelName
    customerName
    qtyOrdered
    totalPrice
    createdAt
    orderedAt
    orderHolds {
      id
      type
      subtype
      description
      createdAt
    }
  }
  ordersAggregate(filter_input: {where: $where}) {
    _count
  }
}
    `) as unknown as TypedDocumentString<OrdersQueryQuery, OrdersQueryQueryVariables>;
export const ListingsQueryDocument = new TypedDocumentString(`
    query ListingsQuery($limit: Int!, $offset: Int!, $where: ListingsBoolExp!, $orderBy: [ListingsOrderByExp!]!) {
  listings(limit: $limit, offset: $offset, where: $where, order_by: $orderBy) {
    id
    name
    description
    externalSkuName
    status
    qtyExpected
    qtyAvailable
    listingStrategy
    qtyListed
    channelName
    createdAt
    updatedAt
  }
  listingsAggregate(filter_input: {where: $where}) {
    _count
  }
}
    `) as unknown as TypedDocumentString<ListingsQueryQuery, ListingsQueryQueryVariables>;
export const AsnsQueryDocument = new TypedDocumentString(`
    query AsnsQuery($limit: Int!, $offset: Int!, $where: AsnsBoolExp!, $orderBy: [AsnsOrderByExp!]!) {
  asns(limit: $limit, offset: $offset, where: $where, order_by: $orderBy) {
    id
    name
    reference
    expectedAt
    locationName
    status
    qtyExpected
    qtyReceived
    closedAt
    createdAt
  }
  asnsAggregate(filter_input: {where: $where}) {
    _count
  }
}
    `) as unknown as TypedDocumentString<AsnsQueryQuery, AsnsQueryQueryVariables>;
export const ReturnsQueryDocument = new TypedDocumentString(`
    query ReturnsQuery($limit: Int!, $offset: Int!, $where: ReturnsBoolExp!, $orderBy: [ReturnsOrderByExp!]!) {
  returns(limit: $limit, offset: $offset, where: $where, order_by: $orderBy) {
    id
    name
    status
    returnCategory
    createdAt
    closedAt
    fromAddressContactName
    order {
      name
    }
    location {
      name
    }
  }
  returnsAggregate(filter_input: {where: $where}) {
    _count
  }
}
    `) as unknown as TypedDocumentString<ReturnsQueryQuery, ReturnsQueryQueryVariables>;